<app-dialog [canScroll]="true" (onClose)="selected($event)">

	@if(selectedItems) {
	<app-explorer [isInDialog]="true" [startAtSites]="true" [selectedItems]="selectedItems" [selectMode]="true" (onSelected)="selectionCompleted($event)"></app-explorer>
	}
</app-dialog>
